import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { createAction } from '@reduxjs/toolkit'

import { TokenAsObject } from './reducer'
// export interface SerializedToken {
//   chainId: number
//   address: string
//   decimals: number
//   symbol?: string
//   name?: string
// }

// export interface SerializedPair {
//  token0: SerializedToken
//  token1: SerializedToken
// }

// export const updateMatchesDarkMode = createAction<{ matchesDarkMode: boolean }>('user/updateMatchesDarkMode')
// export const updateUserDarkMode = createAction<{ userDarkMode: boolean }>('user/updateUserDarkMode')
// export const updateUserFarmFilter = createAction<{ userFarmFilter: string }>('user/updateUserFarmFilter')
// export const updateUserVaultFilter = createAction<{ userVaultFilter: string }>('user/updateUserVaultFilter')
export const updateUserExpertMode = createAction<{ userExpertMode: boolean }>(
  'user/updateUserExpertMode'
)
// export const updateUserSingleHopOnly = createAction<{
//   userSingleHopOnly: boolean
// }>('user/updateUserSingleHopOnly')
export const updateUserSlippageTolerance = createAction<{
  userSlippageTolerance: string
}>('user/updateUserSlippageTolerance')
export const updateUserSlippageToleranceType = createAction<{
  slippageToleranceType: 'auto' | 'custom'
}>('user/updateUserSlippageToleranceType')
export const updateUserDeadlineType = createAction<{
  userDeadlineType: 'auto' | 'custom'
}>('user/updateUserDeadlineType')
export const updateUserDeadline = createAction<{ userDeadline: number }>('user/updateUserDeadline')
export const addCustomToken = createAction<TokenAsObject>('user/addCustomToken')
export const addCustomTokens = createAction<TokenAsObject[]>('user/addCustomTokens')
export const removeCustomToken = createAction<{
  chainId: ChainId
  address: string
}>('user/removeCustomToken')
export const addUserPath = createAction<TokenAsObject>('user/addUserPath')
export const removePath = createAction<{
  chainId: ChainId
  address: string
}>('user/removePath')
export const addPinnedToken = createAction<{currencyId: string}>('user/addPinnedToken')
export const removePinnedToken = createAction<{currencyId: string}>('user/removePinnedToken')
export const updateUserPathType = createAction<{
  userPathType: 'auto' | 'custom'
}>('user/updateUserPathType')
export const resetPath = createAction<{ chainId: ChainId }>('user/resetPath')
export const clearNotifications = createAction<{ account: string }>('user/clearNotifications')
export const createNotification = createAction<{
  account: string
  notification: string
  timestamp: number
}>('user/createNotification')
// export const addSerializedPair = createAction<{
//   serializedPair: SerializedPair
// }>('user/addSerializedPair')
// export const removeSerializedPair = createAction<{
//   chainId: number
//   tokenAAddress: string
//   tokenBAddress: string
// }>('user/removeSerializedPair')
// export const toggleURLWarning = createAction<void>('app/toggleURLWarning')
// export const updateUserArcherUseRelay = createAction<{
//   userArcherUseRelay: boolean
// }>('user/updateUserArcherUseRelay')
// export const updateUserArcherGasPrice = createAction<{
//   userArcherGasPrice: string
// }>('user/updateUserArcherGasPrice')
// export const updateUserArcherETHTip = createAction<{
//   userArcherETHTip: string
// }>('user/updateUserArcherETHTip')
// export const updateUserArcherGasEstimate = createAction<{
//   userArcherGasEstimate: string
// }>('user/updateUserArcherGasEstimate')
// export const updateUserArcherTipManualOverride = createAction<{
//   userArcherTipManualOverride: boolean
// }>('user/updateUserArcherTipManualOverride')
